import React, { useState } from 'react';
import Modal from './Modal';
import GestionGaleria from './GestionGaleria';
import '../../styles/admin/SelectorImagenesGaleria.css';
import { FaTimesCircle } from 'react-icons/fa';

function SelectorImagenesGaleria({ 
  onImagesSelected, 
  initialSelectedImages = [], 
  multiple = true,
  buttonText = "Seleccionar de la Galería" 
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImages, setSelectedImages] = useState(initialSelectedImages);

  // Abrir modal para seleccionar imágenes
  const openGaleriaModal = () => {
    setIsModalOpen(true);
  };

  // Cerrar modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Callback cuando se seleccionan imágenes de la galería
  const handleSelectImagesFromGaleria = (selectedFromGaleria) => {
    // Si no es selección múltiple, reemplazar las imágenes
    const newSelectedImages = multiple 
      ? [...selectedImages, ...selectedFromGaleria] 
      : selectedFromGaleria;
    
    // Eliminar duplicados por URL
    const uniqueImages = [];
    const urls = new Set();
    
    newSelectedImages.forEach(img => {
      if (!urls.has(img.url)) {
        urls.add(img.url);
        uniqueImages.push(img);
      }
    });
    
    setSelectedImages(uniqueImages);
    onImagesSelected(uniqueImages);
    closeModal();
  };

  // Eliminar una imagen de la selección
  const handleRemoveImage = (imageToRemove) => {
    const updatedImages = selectedImages.filter(img => img.url !== imageToRemove.url);
    setSelectedImages(updatedImages);
    onImagesSelected(updatedImages);
  };

  return (
    <div className="selector-imagenes-galeria">
      <div className="selector-header">
        <button
          type="button"
          className="btn-open-galeria"
          onClick={openGaleriaModal}
        >
          {buttonText}
        </button>
      </div>

      {/* Vista previa de imágenes seleccionadas */}
      {selectedImages.length > 0 && (
        <div className="selected-images-preview">
          {selectedImages.map((image, index) => (
            <div key={index} className="selected-image-item">
              <img src={image.url} alt={image.nombre || `Imagen ${index + 1}`} />
              <button 
                type="button" 
                className="btn-remove-image" 
                onClick={() => handleRemoveImage(image)}
                title="Eliminar de la selección"
              >
                <FaTimesCircle />
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Modal con la galería en modo selección */}
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Seleccionar imágenes de la galería"
      >
        <GestionGaleria 
          modoSeleccion={true} 
          onSelectImagen={handleSelectImagesFromGaleria} 
        />
      </Modal>
    </div>
  );
}

export default SelectorImagenesGaleria; 